/**
 * Sign out from anywhere and end on the signed-out home page.
 *
 * Pure (router and logout are handed in) so the rule can be tested; every
 * sign-out control calls this: the header account menu, both Log out buttons
 * on /prompt, and "Not you? Log out" on /details-required.
 *
 * The header menu used to go home FIRST and sign out afterwards, which keeps
 * an ordinary page from redrawing itself for a moment without a user. But a
 * member held by a required prompt cannot go home: the wall middleware sends
 * that navigation straight back to /prompt. The sign-out then happened ON
 * /prompt, which stayed on screen with its card or form, now for nobody
 * (owner, 25 Sep 2026). Worse, the header's "Sign in" there carries
 * `redirectUrl=/prompt`, so the next account to sign in was taken to a
 * prompt page with nothing to show them: a blank screen that read as "can't
 * log in to this account".
 *
 * So: try home first, as before. If the navigation did not land on home (a
 * wall held it), sign out where we are and THEN go home, which nothing can
 * hold any more.
 */
export async function signOutToHome({router, logout, home = '/'}) {
  let landed = false;
  try {
    await router.push(home);
    landed = router.currentRoute.value?.path === home;
  } catch {
    landed = false;
  }
  await logout();
  if (!landed) await router.replace(home);
}
